// algoliaConfig.tsx
import algoliasearch, { SearchClient } from 'algoliasearch/lite';

const searchClient: SearchClient = algoliasearch('TBC121MYQX', 'd2962f2eafdfcfa8639adfd62f9ad2bc');

export default searchClient;
